import { Card, Button, Alert, Typography } from "antd";
import { useNavigate } from "react-router-dom";

const { Paragraph, Text } = Typography;

export default function ForgotPassword() {
  const navigate = useNavigate();

  return (
    <Card title="Forgot Password" style={{ width: 380 }} bordered={false}>
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 20 }}
        message="Password reset is handled by an administrator"
      />

      <Paragraph style={{ color: "var(--color-text-secondary)", marginBottom: 8 }}>
        Self-service password reset is not available.
      </Paragraph>

      <Paragraph style={{ color: "var(--color-text-secondary)", marginBottom: 24 }}>
        Please contact your{" "}
        <Text strong>Super Admin</Text> or{" "}
        <Text strong>Operations Admin</Text> and ask them to reset your
        password from{" "}
        <Text strong>Users &amp; Leaves → Security &amp; Passwords</Text>.
        A temporary password will be emailed to you, and you will be asked to
        change it on your next login.
      </Paragraph>

      <Button type="primary" block size="large" onClick={() => navigate("/login")}>
        Back to Login
      </Button>
    </Card>
  );
}
